import CodeError from '@/helpers/CodeError';
import { env } from '@/helpers/constants';

const baseUrl = {
  local: 'https://cart-dev.corpinter.net',
  development: '',
  int: '',
  qa: '',
  production: '',
};

const base = baseUrl[env];

export const campaignRequestEndpoint = `${base}/backend/campaign-request`;
export const administrationEndpoint = `${base}/backend/administration`;
export const usersRequestEndPoint = `${base}/backend/users`;
export const documentationEndPoint = `${base}/backend/documentation`;
export const affectedVehiclesEndPoint = `${base}/backend/vehicles`;
export const notificationsEndPoint = `${base}/backend/notification`;
export const externalServicesEndPoint = `${base}/backend/external-services`;
export const cartIntelligenceEndPoint = `${base}/backend/intelligence`;

export const socketHubEndpoint = `${administrationEndpoint}/ws`;

export const checkServiceOK = async (response, isText = false) => {
  if (response.ok) {
    if (isText) return response.text();
    const text = await response.text();

    return text ? JSON.parse(text) : null;
  }

  let error = new Error();

  try {
    const resJson = await response.json();
    error = new CodeError(resJson.errorMessage || resJson.error, resJson.errorCode || resJson.status, response.status, resJson.errorData);

    return Promise.reject(error);
  } catch (err) {
    if (response.status !== 401 && !response.bodyUsed) {
      error = new CodeError(err.message || response.statusText, err.errorCode || response.status, response.status);
    } else {
      error = null;
    }
    throw error;
  }
};

export const checkFileOk = async (response) => {
  if (response.ok) {
    const fileName = response?.headers?.get?.('content-disposition')?.split?.('=')?.pop?.()?.replaceAll?.('"', '') ?? null;
    const blob = await response.blob();

    return {
      blob,
      fileName,
    };
  }

  try {
    const resJson = await response.json();
    throw new Error(resJson.message || resJson.statusText || resJson.errorMessage);
  } catch (err) {
    throw new Error(err.message || response.statusText || response.errorMessage);
  }
};
